var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L21.434 16.7773L24.5 17.2227L22.25 19.25L23 22.25L20 20.5625L17 22.25L17.75 19.25L15.5 17.2227L18.65 16.7773L20 14Z",
    fill: "url(#paint0_linear_5055_29537)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.302 30.5L20 29.75L23 24.5H27.5C27.6971 24.5003 27.8923 24.4617 28.0744 24.3864C28.2565 24.3111 28.422 24.2007 28.5613 24.0613C28.7007 23.922 28.8111 23.7565 28.8864 23.5744C28.9617 23.3923 29.0003 23.1971 29 23V14C29.0003 13.8029 28.9617 13.6077 28.8864 13.4256C28.8111 13.2435 28.7007 13.078 28.5613 12.9387C28.422 12.7993 28.2565 12.6889 28.0744 12.6136C27.8923 12.5383 27.6971 12.4997 27.5 12.5H12.5C12.3029 12.4997 12.1077 12.5383 11.9256 12.6136C11.7435 12.6889 11.578 12.7993 11.4387 12.9387C11.2993 13.078 11.1889 13.2435 11.1136 13.4256C11.0383 13.6077 10.9997 13.8029 11 14V23C10.9997 23.1971 11.0383 23.3923 11.1136 23.5744C11.1889 23.7565 11.2993 23.922 11.4387 24.0613C11.578 24.2007 11.7435 24.3111 11.9256 24.3864C12.1077 24.4617 12.3029 24.5003 12.5 24.5H19.25V26H12.5C11.7044 26 10.9413 25.6839 10.3787 25.1213C9.81607 24.5587 9.5 23.7956 9.5 23V14C9.4999 13.606 9.57743 13.2159 9.72816 12.8518C9.87889 12.4878 10.0999 12.1571 10.3785 11.8785C10.6571 11.5999 10.9878 11.3789 11.3518 11.2282C11.7159 11.0774 12.106 10.9999 12.5 11H27.5C27.894 10.9999 28.2841 11.0774 28.6482 11.2282C29.0122 11.3789 29.3429 11.5999 29.6215 11.8785C29.9001 12.1571 30.1211 12.4878 30.2718 12.8518C30.4226 13.2159 30.5001 13.606 30.5 14V23C30.5 23.7956 30.1839 24.5587 29.6213 25.1213C29.0587 25.6839 28.2956 26 27.5 26H23.8738L21.302 30.5Z",
    fill: "url(#paint1_linear_5055_29537)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5055_29537",
    x1: -0.864476,
    y1: 2.01211,
    x2: 32.1051,
    y2: -4.43014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5055_29537",
    x1: -28.6838,
    y1: -17.335,
    x2: 48.3174,
    y2: -32.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.1b2753f69e644282e26c64d4eefb3fac.svg";
export { ForwardRef as ReactComponent };